<script setup lang="ts">
import { twMerge } from "tailwind-merge"

const props = defineProps<{ class?: string }>()
</script>

<template>
  <p :class="twMerge('text-xs text-zinc-500', props.class)"><slot /></p>
</template>
